import { render, staticRenderFns } from "./sport_competition_notify_loser.vue?vue&type=template&id=5a2a1fe1&scoped=true&"
import script from "./sport_competition_notify_loser.vue?vue&type=script&lang=js&"
export * from "./sport_competition_notify_loser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a1fe1",
  null
  
)

export default component.exports